export default __webpack_public_path__ + "static/media/siminn-icons.1aee7ada.ttf";